import { z } from 'zod';

/**
 * Time range for a single day.
 */
export const dayHoursSchema = z.object({
  open: z.string(),
  close: z.string(),
});

export type DayHours = z.infer<typeof dayHoursSchema>;

/**
 * Operating hours by day of week.
 * Used for location hours and provider schedules.
 */
export const operatingHoursSchema = z.object({
  monday: dayHoursSchema.nullable().optional(),
  tuesday: dayHoursSchema.nullable().optional(),
  wednesday: dayHoursSchema.nullable().optional(),
  thursday: dayHoursSchema.nullable().optional(),
  friday: dayHoursSchema.nullable().optional(),
  saturday: dayHoursSchema.nullable().optional(),
  sunday: dayHoursSchema.nullable().optional(),
});

export type OperatingHours = z.infer<typeof operatingHoursSchema>;
